import React, { FC, useEffect, useState } from 'react';
import translation from '../../../languages';
import Dropdown, { DropdownOption } from '../../dropdown/dropdown';
import './search-dropdown.scss';

enum DropdownChoice {
    'INTERACTIVES_ONLY' = 0,
    'ALL' = 1
}

type SearchDropdownProps = TranslationProps & {
    toggleOnlyInteractivesSearch: (onlyInteractives: boolean) => void;
};

const SearchDropdown: FC<SearchDropdownProps> = ({ toggleOnlyInteractivesSearch, t }) => {
    const [activeOption, setActiveOption] = useState<DropdownChoice>(DropdownChoice.INTERACTIVES_ONLY);
    const updateOption = (option: DropdownChoice): void => {
        setActiveOption(option);
        toggleOnlyInteractivesSearch(option === DropdownChoice.INTERACTIVES_ONLY);
    };
    const saveSelectionToLocalStorage = (option: DropdownOption): void => {
        window.localStorage.setItem('interactive-search-option', option.id.toString());
        updateOption(option.id as DropdownChoice);
    };

    useEffect(() => {
        updateOption(Number(window.localStorage.getItem('interactive-search-option')));

        return () => {
            toggleOnlyInteractivesSearch(false);
        };
    }, []);

    const dropdownOptions: DropdownOption[] = [
        {
            id: DropdownChoice.INTERACTIVES_ONLY,
            title: t('common.materialBlock.interactive'),
            active: activeOption === DropdownChoice.INTERACTIVES_ONLY,
            'data-testid': 'search-interactives-only'
        },
        {
            id: DropdownChoice.ALL,
            title: t('cabinetSales.vouchers.forAll'),
            active: activeOption === DropdownChoice.ALL,
            'data-testid': 'search-all-materials'
        }
    ];
    const selectedOption: DropdownOption = dropdownOptions.filter((option) => option.active)[0];

    return (
        <Dropdown
            onSelect={saveSelectionToLocalStorage}
            className='interactive-search-dropdown'
            options={dropdownOptions}
            selectedValue={selectedOption}
        />
    );
};

const translate = translation(['cabinet-sales']);

export default translate(SearchDropdown);
